import React from "react";
import toast from "react-hot-toast";
import { FiDownload } from "react-icons/fi";
import { MESSAGES } from "../constants";
import * as XLSX from "xlsx";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory } from "@capacitor/filesystem";

const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.readAsDataURL(blob);
  });

const DownloadCSVButton = ({ fetchData }) => {
  const handleDownload = async () => {
    try {

      const response = await fetchData();
      console.log("Download API Response:", response?.data);
      const data = response?.data;

      if (!Array.isArray(data) || data.length === 0) {
        toast.error(MESSAGES.NO_DATA_AVAILABLE);
        return;
      }

      const keyToLabel = {
        user_name: "User Name",
        date: "Date",
        day_start_time: "Day Start Time",
        day_end_time: "Day End Time",
        day_status: "Day Status",
        day_start_latitude: "Day Start Latitude",
        day_start_longitude: "Day Start Longitude",
        comment: "Comment",
        task_title: "Task Title",
        task_description: "Task Description",
        client_name: "Client Name",
        client_address: "Client Address",
        latitude: "Latitude",
        longitude: "Longitude",
        start_time: "Start Time",
        end_time: "End Time",
        is_last_task: "Is Last Task",
        status: "Status",
        day_end_latitude: "Day End Latitude",
        day_end_longitude: "Day End Longitude",
      };
      const formatted = data.map((item) => {
        const row = {};
        for (const [key, label] of Object.entries(keyToLabel)) {
          row[label] = item[key] != null && item[key] !== ""? item[key]: "N/A";
        }
        return row;
      });

      const worksheet = XLSX.utils.json_to_sheet(formatted);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Tasks");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([wbout], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const fileName = `tasks-${Date.now()}.xlsx`;
      const platform = Capacitor.getPlatform();

      if (platform === "web") {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        toast.success(MESSAGES.EXCEL_DOWNLOAD_SUCCESSFUL);
      } else {
        const base64Data = await blobToBase64(blob);

        const fileOptions = {
          path: fileName,
          data: base64Data,
          recursive: true,
        };

        try {
          await Filesystem.writeFile({
            ...fileOptions,
            directory: Directory.Documents,
          });
        } catch (e) {
          await Filesystem.writeFile({
            ...fileOptions,
            directory: Directory.ExternalStorage,
          });
        }

        toast.success(MESSAGES.SAVED_TO_DEVICE);
      }
    } catch (error) {
      toast.error(MESSAGES.DOWNLOAD_FAILED);
    }
  };

  return (
    <button
      onClick={handleDownload}
      className="px-4 py-3 md:mt-2 bg-blue-100 text-primary rounded hover:hoverColor"
    >
      <FiDownload size={16} />
    </button>
  );
};

export default DownloadCSVButton;
